import React from 'react';
import { useMutation } from 'hooks/apollo';

import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Slider, Checkbox, Row, Col } from 'antd';

import globalMessages from 'translations/messages';
import MultilineInput from 'components/MultilineInput';
import useGlobalContext from 'hooks/useGlobalContext';
import { DeviceType } from 'shared/services/prisma/types';
import messages from './messages';
import mutation from './updateAudience.gql';

const deviceTypes = Object.values(DeviceType);

const EditDistributionAudience = ({ intl: { formatMessage: $t }, distribution, form, onDone }) => {
  const [save] = useMutation(mutation);
  const { message } = useGlobalContext();

  const onFinish = async (values) => {
    try {
      await save({
        variables: {
          id: distribution.id,
          portion: values.portion,
          deviceTypes: values.deviceTypes,
          excludedIPs: values.excludedIPs,
        },
      });
      message.success($t(messages.saveAudienceSuccess));
    } catch (error) {
      message.error($t(messages.saveAudienceError));
    }
    if (onDone) {
      onDone();
    }
  };

  const initialValues = {
    portion: distribution.portion || 100,
    deviceTypes: distribution.deviceTypes.length ? distribution.deviceTypes : deviceTypes,
    excludedIPs: distribution.excludedIPs,
  };

  return (
    <Form layout="vertical" form={form} onFinish={onFinish} initialValues={initialValues}>
      <Row gutter={16}>
        <Col sm={24} md={12}>
          <Form.Item name="portion" label={<FormattedMessage {...messages.portion} />}>
            <Slider
              min={0}
              max={100}
              tooltip={{
                formatter: (v) => `${v}%`,
              }}
              marks={{ 25: '25%', 50: '50%', 75: '75%', 100: '100%' }}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={{ span: 10, offset: 2 }}>
          <Form.Item name="deviceTypes" label={<FormattedMessage {...messages.deviceTypes} />}>
            <Checkbox.Group options={deviceTypes.map(value => ({ label: <FormattedMessage {...globalMessages[value.toLowerCase()]} />, value }))} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="excludedIPs" label={<FormattedMessage {...messages.excludedIPs} />}>
        <MultilineInput placeholder={$t(messages.excludedIPsPlaceholder)} />
      </Form.Item>
    </Form>
  );
};

export default injectIntl(EditDistributionAudience);
